<template>
  <div class="my-1 card">
    <div class="my-0 py-1 card-header text-info">
      <h4 class="my-0 py-1">
        Services, scope values and additional scopes for the selected services
      </h4>
    </div>
    <div class="card-body">
      <div class="form-group" v-if="isServiceconfig">
        <label for="exampleInputEmail1">Choose Services</label>
        <div
          v-bind:key="ser.$model.slug"
          v-for="(ser, serviceIndex) in $v.services.$each.$iter"
        >
          <div>
            <span class="d-inline-block custom-control custom-checkbox">
              <input
                type="checkbox"
                v-model="ser.$model.isSelected"
                v-bind:id="ser.$model.slug"
                v-bind:key="ser.$model.slug"
                class="custom-control-input"
              />
              <label
                class="custom-control-label"
                v-bind:for="ser.$model.slug"
                >{{ ser.$model.title }}</label
              >
            </span>
            <font-awesome-icon
              v-bind:key="ser.$model.slug"
              size="sm"
              title="is optional?"
              v-if="ser.$model.isSelected && !ser.$model.isOptional"
              class="d-inline-block ml-2 text-info"
              @click="
                if (ser.$model.serviceConfig) {
                  ser.$model.serviceConfig.isOptional = ser.$model.isOptional =
                    !ser.$model.isOptional;
                } else {
                  ser.$model.isOptional = !ser.$model.isOptional;
                }
              "
              v-bind:icon="['fa', 'toggle-off']"
            ></font-awesome-icon>
            <font-awesome-icon
              size="sm"
              v-bind:key="ser.$model.slug"
              v-if="ser.$model.isSelected && ser.$model.isOptional"
              title="is optional?"
              class="d-inline-block ml-2 text-info"
              @click="
                if (ser.$model.serviceConfig) {
                  ser.$model.serviceConfig.isOptional = ser.$model.isOptional =
                    !ser.$model.isOptional;
                } else {
                  ser.$model.isOptional = !ser.$model.isOptional;
                }
              "
              v-bind:icon="['fa', 'toggle-on']"
            ></font-awesome-icon>
            <font-awesome-icon
              size="sm"
              v-bind:key="ser.$model.slug + '_addnlscope'"
              v-if="
                ser.$model.isSelected &&
                ser.$model.serviceConfig &&
                !editMode &&
                !addMode
              "
              title="Add Scope"
              @click="handleAdd(ser.$model.serviceConfig)"
              class="d-inline-block ml-2 text-info"
              v-bind:icon="['fa', 'plus']"
            ></font-awesome-icon>
          </div>
          <div
            style="margin-left: 3%"
            v-if="ser.$model.isSelected && ser.$model.serviceConfig"
          >
            <!--<h4>{{ ser.serviceConfig.title }}</h4>-->
            <div
              v-bind:key="scope.slug"
              v-for="(scope, scopeIndex) in ser.$model.serviceConfig.scopes"
            >
              <div
                v-if="
                  ser.$model.serviceConfig.hasSubTasks && scope.isSubTaskScope
                "
              >
                <span class="d-inline-block custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    v-model="scope.isActive"
                    v-bind:id="scope.slug"
                    v-bind:key="scope.slug"
                    class="custom-control-input"
                  />
                  <label class="custom-control-label" v-bind:for="scope.slug">{{
                    scope.title
                  }}</label>
                </span>
              </div>
              <!-- <h4>{{scope.title}}</h4> -->
              <div v-if="scope.isActive">
                <small
                  v-if="
                    scope.description.indexOf(
                      'All work to be completed within'
                    ) == -1
                  "
                  >{{ scope.description }}</small
                >
                <div
                  class="form-group"
                  v-bind:key="scopeInput.slug"
                  v-for="(scopeInput, inputIndex) in scope.inputs"
                >
                  <div
                    v-if="scopeInput.title.indexOf('Time To Complete') == -1"
                  >
                    <label v-bind:for="scopeInput.slug">
                      {{ scopeInput.title }}
                    </label>
                    <input
                      v-if="formatType(scopeInput.type) != 'Select'"
                      class="form-control"
                      type="text"
                      v-bind:id="scopeInput.slug"
                      v-model="scopeInput.defaultValue"
                    />

                    <select
                      v-if="formatType(scopeInput.type) == 'Select'"
                      v-model="scopeInput.defaultValue"
                      class="form-control"
                      id="scopeInput.slug"
                      @change="selectedScopeInput(scopeInput.defaultValue)"
                    >
                      <option
                        v-for="serop in scopeInput.inputs"
                        v-bind:key="serop.slug"
                        v-bind:value="serop.title"
                        v-bind:inputs="serop.inputs"
                      >
                        {{ serop.title }}
                      </option>
                    </select>
                    <!-- {{ ser }} -->
                    <div
                      class="error"
                      v-if="
                        !ser.serviceConfig.scopes.$each.$iter[scopeIndex].inputs
                          .$each.$iter[inputIndex].defaultValue.isValid
                      "
                    >
                      Please enter a valid value for
                      {{
                        ser.serviceConfig.scopes.$each.$iter[scopeIndex].inputs
                          .$each.$iter[inputIndex].$model.title
                      }}
                    </div>
                    <div
                      class="error"
                      v-if="
                        !ser.serviceConfig.scopes.$each.$iter[scopeIndex].inputs
                          .$each.$iter[inputIndex].$model.defaultValue &&
                        selectedIncidentType != 'it-post-ir'
                      "
                    >
                      Please enter a value for
                      {{
                        ser.serviceConfig.scopes.$each.$iter[scopeIndex].inputs
                          .$each.$iter[inputIndex].$model.title
                      }}
                    </div>
                    <div
                      v-if="
                        selectedSpecification &&
                        datamining &&
                        scopeInput.title == 'Specification'
                      "
                    >
                      <div
                        class="form-group"
                        v-bind:key="Specification.slug"
                        v-for="(
                          Specification, sepcindex
                        ) in selectedSpecification.inputs"
                      >
                        <label>{{ Specification.title }}</label>
                        <select
                          v-if="formatType(Specification.type) == 'Select'"
                          v-model="Specification.defaultValue"
                          class="form-control"
                          id="Specification.slug"
                        >
                          <option
                            v-for="serop in Specification.inputs"
                            v-bind:key="serop.slug"
                            v-bind:value="serop.title"
                          >
                            {{ serop.title }}
                          </option>
                        </select>
                        <input
                          v-if="formatType(Specification.type) == 'Number'"
                          class="form-control"
                          type="number"
                          v-bind:id="Specification.slug"
                          v-model="Specification.defaultValue"
                        />
                        <input
                          v-if="formatType(Specification.type) == 'Text'"
                          class="form-control"
                          type="text"
                          v-bind:id="Specification.slug"
                          v-model="Specification.defaultValue"
                        />
                        <div class="error" v-if="!Specification.defaultValue">
                          Please enter a valid value for
                          {{ Specification.title }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="font-italic text-success">
              <div
                v-bind:key="scope.slug"
                v-for="scope in ser.$model.serviceConfig.additionalScopes"
              >
                <div>
                  <div>
                    <!-- <h5
                      :class="{ 'text-danger': !scope.IsActive }"
                      class="d-inline font-weight-bold my-1"
                    >
                      {{ scope.title }}
                    </h5>-->
                    <p
                      :class="{ 'text-danger': !scope.isActive }"
                      class="d-inline font-weight-bold my-1"
                    >
                      <small
                        v-if="scope.description"
                        class="font-weight-light my-1"
                        >{{ scope.description }}</small
                      >
                    </p>
                    <font-awesome-icon
                      size="sm"
                      v-if="!editMode && !addMode && scope.isActive"
                      class="ml-2 text-info"
                      @click="handleTaskEdit(scope)"
                      :icon="['fas', 'pen']"
                    ></font-awesome-icon>
                    <font-awesome-icon
                      size="sm"
                      v-if="!editMode && !addMode"
                      @click="scope.isActive = !scope.isActive"
                      class="ml-2"
                      :class="{
                        'text-danger': !scope.isActive,
                        'text-info': scope.isActive,
                      }"
                      :icon="['fas', 'trash-alt']"
                    ></font-awesome-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <small id="lawfirmHelp" class="form-text text-muted">
          Selected services will drive the tasks and scope values in the
          generated SoW
        </small>
      </div>
      <div v-else>
        <p>
          Present no services configured for
          <strong>{{ subofferingfilter(selectedSubType) }}</strong> click on
          next.
        </p>
      </div>

      <button class="btn btn-secondary" @click="goback">
        <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon
        >Back
      </button>
      <button
        class="btn btn-info mx-2"
        v-bind:disabled="nextable"
        @click="gonext"
      >
        Next
        <font-awesome-icon :icon="['fas', 'arrow-right']"></font-awesome-icon>
      </button>
    </div>
    <div v-if="editMode || addMode" class="sidepanel">
      <div class="pl-1 pr-1">
        <div class="form-group">
          <label for="txtTitle" class="font-weight-bold text-white"
            >Title</label
          >
          <input
            type="text"
            class="form-control"
            id="txtTitle"
            v-model="editItem.title"
          />
          <small class="text-white form-text">{{ editItem.title }}</small>
        </div>
        <div class="form-group">
          <label for="exampleInputPassword1" class="font-weight-bold text-white"
            >description</label
          >
          <textarea
            class="form-control"
            v-model="editItem.description"
          ></textarea>
          <small class="text-white form-text">{{ editItem.description }}</small>
        </div>
        <button
          type="button"
          class="btn btn-dark"
          @click="
            editMode = false;
            addMode = false;
            editItem.title = '';
            editItem.description = '';
          "
        >
          Cancel
        </button>
        <button type="button" class="ml-2 btn btn-info" @click="handleEditSave">
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import serviceProxy from "../services/index";
import _ from "lodash";
import uuidv1 from "uuid/v1";
import { required, numeric, decimal, helpers } from "vuelidate/lib/validators";

export default {
  name: "Scope",
  created() {
    //#region  SerivceOrderMapping
    var serviceOrderMapping = [
      {
        slug: "svc-ran-dec-val",
        Order: 1,
      },
      {
        slug: "svc-inc-res-thr-int",
        Order: 2,
      },
      {
        slug: "svc-inc-res",
        Order: 3,
      },
      {
        slug: "svc-thr-int",
        Order: 4,
      },
      {
        slug: "svc-onsite",
        Order: 5,
      },
      {
        slug: "svc-inv-for-log-ana",
        Order: 6,
      },
      {
        slug: "svc-inv-for-sys-ana",
        Order: 7,
      },
      {
        slug: "svc-acq-pres",
        Order: 8,
      },
      {
        slug: "svc-sec-val-mon-con",
        Order: 8,
      },
      {
        slug: "svc-reporting",
        Order: 9,
      },
      {
        slug: "svc-dark-web-search",
        Order: 10,
      },
      {
        slug: "svc-email-phishing-analysis",
        Order: 11,
      },
    ];
    //#endregion
    var that = this;
    that.$root.$emit("stage", 3);
    let mrdata = that.$store.getters.masterData;
    let selServices = that.$store.getters.selectedServices;
    let incidentType = that.$store.getters.selectedIncidentType;
    let suboffType = that.$store.getters.selectedSubofferingType;
    if (!selServices) {
      selServices = [];
    }
    var services = _.map(mrdata.services, (ser) => {
      var localSer = { ...ser };
      var selService = _.find(
        selServices,
        (selser) => selser.slug === localSer.slug
      );
      var items = [];
      if (selService) {
        localSer.isSelected = selService.isSelected ? true : false;
        localSer.isOptional = selService.isOptional ? true : false;
        localSer.Address = selService.Address ? selService.Address : null;
        localSer.Country = selService.Country ? selService.Country : null;
      }
      //  else {
      //   localSer.isSelected = false;
      //   localSer.isOptional = false;
      // }
      var serviceOverwritesElement = _.find(
        localSer.overViewOverWrites,
        (ow) => {
          return ow.incidentTypeSlug === incidentType;
        }
      );
      var titleOverwritesElement = _.find(localSer.titleOverWrites, (to) => {
        return to.incidentTypeSlug === incidentType;
      });
      var serviceOrderElement = localSer.order;
      _.each(localSer.overView, (ov, index) => {
        items.push({
          description: ov,
        });
      });
      var serviceOverViewElement = (localSer.overView = { Items: items });
      var localMap = _.find(
        serviceOrderMapping,
        (map) => map.slug === localSer.slug
      );
      localSer.serviceOrder = serviceOrderElement
        ? parseInt(serviceOrderElement)
        : localMap
        ? localMap.Order
        : 999;

      // localSer.overView = serviceOverwritesElement
      //   ? !serviceOverwritesElement.isDisabled
      //     ? serviceOverwritesElement
      //     : serviceOverViewElement
      //   : null;
      let incidentTypeServiceTitle = titleOverwritesElement
        ? titleOverwritesElement.isDisabled == false
          ? titleOverwritesElement.title
          : null
        : null;
      // element.serviceTitle = element.ServiceTitle
      //   ? element.ServiceTitle
      //   : serviceTitle; //element.isOptional ? 'OPTIONAL - ' + serviceTitle : serviceTitle;
      localSer.title = incidentTypeServiceTitle
        ? incidentTypeServiceTitle
        : ser.title;
      return localSer;
    });
    services = _.filter(services, (ser) => {
      if (ser.titleOverWrites) {
        var titleOverwritesElement = _.find(ser.titleOverWrites, (to) => {
          if (to.subofferingTypeSlug) {
            return (
              to.incidentTypeSlug === incidentType &&
              to.subofferingTypeSlug === suboffType
            );
          } else {
            return to.incidentTypeSlug === incidentType;
          }
        });
        return titleOverwritesElement
          ? !titleOverwritesElement.isDisabled
          : false;
      } else {
        return true;
      }
    });
    services = _.sortBy(
      services,
      (unorderedService) => unorderedService.serviceOrder
    );
    if (!that.$store.getters.hasServicesConfig) {
      that.$root.$emit("progress");
      that.$root.$emit("toast", {
        title: "Fetching Service",
        message: "Fetching the service configuration for the selected services",
      });
      /*
          1. Get the selected services
          2. 
      */
      //let services = that.$store.getters.selectedServices;
      let servicesCSV = _.map(services, (ser) => {
        return ser.slug;
      }).join(",");
      let masterConfig = null;
      if (that.$store.getters.selectedIncidentType == "it-mdr") {
        masterConfig =
          that.$store.getters.selectedMDRTemplateConfig.masterServiceConfig;
      } else {
        masterConfig =
          that.$store.getters.selectedTemplateConfig.masterServiceConfig;
      }
      serviceProxy.serviceConfig
        .getConfig(this.$store.getters.token, servicesCSV, masterConfig)
        .then((data) => {
          let servicesConfig = data.data.data;
          this.isServiceconfig = servicesConfig.length ? true : false;
          for (let index = 0; index < servicesConfig.length; index++) {
            const element = servicesConfig[index];
            const selService = _.find(services, (ser) => {
              return ser.slug === element.serviceId;
            });
            element.isOptional = selService.isOptional;
            selService.serviceConfig = element;
            selService.serviceConfig.additionalScopes = [];
            //element.serviceTitle = element.isOptional ? `OPTIONAL - ${selService.title}` : `${selService.title}`;
            that.servicesConfig.push(element);
          }
          that.$store.commit("servicesConfig", servicesConfig);
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "Fetched Template",
            message:
              "Fetched the service configuration for the selected services",
          });
          _.each(services, (service) => {
            if (service.serviceConfig.isActive) {
              that.services.push(service);
            }
          });
        })
        .catch((e) => {
          console.log(e);
          that.$root.$emit("done");
        });
    } else {
      let servicesConfig = this.$store.getters.servicesConfig;
      let that = this;
      this.isServiceconfig = servicesConfig.length ? true : false;
      that.selectedvalue = null;
      for (let index = 0; index < servicesConfig.length; index++) {
        const element = servicesConfig[index];
        const selService = _.find(services, (ser) => {
          return ser.slug === element.serviceId;
        });
        if(selService){
          selService.serviceConfig = element;
        that.servicesConfig.push(element);
        }
      }
      _.each(services, (service) => {
        let that = this;
        if (
          service.slug == "svc-dat-bre-ana-pha-2" &&
          service.isSelected == true
        ) {
          service.sowDmService = true;
          service.Address = service.slug;
          _.each(service.serviceConfig.scopes, (serviceScope) => {
            _.each(serviceScope.inputs, (serviceScopeInput) => {
              if (this.formatType(serviceScopeInput.type) == "Select") {
                that.selectedvalue = serviceScopeInput.defaultValue;
              }
            });
          });
        } else if (
          service.slug == "svc-dat-bre-ana-pha-1" &&
          service.isSelected == true
        ) {
          service.sowDmService = true;
          service.Country = service.slug;
          _.each(service.serviceConfig.scopes, (serviceScope) => {
            _.each(serviceScope.inputs, (serviceScopeInput) => {
              if (this.formatType(serviceScopeInput.type) == "Select") {
                that.selectedvalue = serviceScopeInput.defaultValue;
              }
            });
          });
        }
        that.services.push(service);
      });
      that.dmservice = _.clone(
        _.filter(
          services,
          (ds) =>
            (ds.slug == "svc-dat-bre-ana-pha-2" && ds.isSelected == true) ||
            ds.Address == "svc-dat-bre-ana-pha-2"
        )
      );

      if (!_.find(services, (ds) => ds.Country == "svc-dat-bre-ana-pha-1")) {
        if (that.dmservice.length > 0 && this.IsamendmentMode) {
          that.services = _.clone(
            _.reject(that.services, ["slug", "svc-dat-bre-ana-pha-1"])
          );
        }
      }
      //that.services = services;
      let servicesData = this.$store.getters.servicesData;
      _.each(servicesData, (serviceData) => {
        let service = _.find(servicesConfig, (service) => {
          return service.slug === serviceData.slug;
        });
        service.additionalScopes = serviceData.AdditionalScopes;
        _.each(serviceData.ScopeInputs, (serviceDataScopeInput) => {
          _.each(service.scopes, (scope) => {
            let serviceScopeInput = _.find(scope.ScopeInputs, (input) => {
              input.slug === serviceDataScopeInput.slug;
            });
            if (serviceScopeInput) {
              serviceScopeInput.defaultValue =
                serviceDataScopeInput.defaultValue;
            }
          });
        });
      });
      if (this.selectedvalue != null) {
        that.selectedScopeInput(this.selectedvalue);
      }
    }
  },
  props: {},
  methods: {
    formatType: function (value) {
      let that = this;
      let type = _.filter(that.inputoptions, (mr) => mr.value === value);
      return (value = type.length ? type[0].text : value);
    },
    subofferingfilter(value) {
      let that = this;
      if (!value) {
        return "";
      }
      value = value.toString();
      let soffering = _.filter(
        that.$store.getters.masterData.subofferingTypes,
        (lm) => lm.slug === value
      );
      return soffering[0].title;
    },
    goback: function (oEvent) {
      this.$router.go(-1);
    },
    gonext: function (oEvent) {
      /*
        1. Save the PlaceHolder Values - slug, Value
      */
      var that = this;
      var services = _.filter(this.services, (ser) => {
        return ser.isSelected;
      });
      if (this.IsamendmentMode) {
        let sowDmService = _.filter(this.services, (ser) => {
          return ser.sowDmService;
        });
        if (sowDmService.length) {
          if (sowDmService[0].slug == "svc-dat-bre-ana-pha-2") {
            services[0].Address = sowDmService[0] ? sowDmService[0].slug : "";
          } else if (sowDmService[0].slug == "svc-dat-bre-ana-pha-1") {
            services[0].Country = sowDmService[0] ? sowDmService[0].slug : "";
          }
        }
      }
      let servicesData = [];
      _.each(services, (ser) => {
        var service = ser.serviceConfig;
        if (service) {
          let serviceData = {};
          serviceData.Code = service.slug;
          serviceData.servicecode = service.serviceId;
          serviceData.scopes = [];
          serviceData.AdditionalScopes = [];
          serviceData.ScopeInputs = [];
          serviceData.slug = service.slug;
          serviceData.ServiceOverview = service.ServiceOverview
            ? service.ServiceOverview
            : ser.overView
            ? ser.overView
            : null;
          serviceData.ServiceOrder = ser.serviceOrder;
          serviceData.HasSubTasks = service.hasSubTasks;
          //serviceData.serviceTitle = service.serviceTitle;
          serviceData.isOptional = service.isOptional;
          serviceData.AdditionalScopes = service.additionalScopes;
          _.each(service.scopes, (scope) => {
            let description = scope.description;
            _.each(scope.inputs, (scopeInput) => {
              description = description.replace(
                "{" + scopeInput.slug + "}",
                scopeInput.defaultValue
              );
              serviceData.ScopeInputs.push({
                slug: scopeInput.slug,
                value: scopeInput.defaultValue,
              });
            });
            serviceData.scopes.push({
              slug: scope.slug,
              value: description,
            });
          });
          servicesData.push(serviceData);
        }
      });
      this.$store.commit("servicedatascopes", {
        servicesData: servicesData,
        selectedServices: services,
      });
      this.$store.commit("setrateCardsDetails", null);
      this.$router.push({ path: "review-content" });
    },
    handleAdd(service) {
      this.addMode = true;
      this.editItem.title = "";
      this.editItem.description = "";
      this.editingService = service;
    },
    handleTaskEdit(task) {
      task.taskViewMode = !task.taskViewMode;
      this.editMode = true;
      this.editItem.title = task.title;
      this.editItem.description = task.description;
      this.editingTask = task;
    },
    handleEditSave() {
      if (this.editMode) {
        this.editingTask.title = this.editItem.title;
        this.editingTask.description = this.editItem.description;
        this.editingTask = {};
        this.editMode = false;
      } else {
        this.editingService.additionalScopes.push({
          title: this.editItem.title,
          description: this.editItem.description,
          slug: uuidv1(),
          isActive: true,
          IsActive: true,
        });
        this.addMode = false;
      }
      this.editItem.title = "";
      this.editItem.description = "";
    },
    selectedScopeInput(scopeInput) {
      if (scopeInput) {
        let selectedServiceInput = scopeInput;
        let selectedSpecification = "";
        let selectedServices = _.filter(this.services, (ser) => ser.isSelected);
        let dmservice1 = _.find(selectedServices, (service) => {
          return _.includes(service, "svc-dat-bre-ana-pha-1");
        });
        let dmservice2 = _.find(selectedServices, (service) => {
          return _.includes(service, "svc-dat-bre-ana-pha-2");
        });
        this.datamining = true;
        let dmservices = dmservice1 ? dmservice1 : dmservice2;
        _.each(dmservices.serviceConfig.scopes, (scopes) => {
          _.each(scopes.inputs, (scopeInputs) => {
            selectedSpecification = _.find(scopeInputs.inputs, (service) => {
              return _.includes(service, selectedServiceInput);
            });
          });
        });
        this.selectedSpecification = selectedSpecification;
      }
    },
    ValidateSpecification() {
      let that = this;
      if (that.selectedSpecification != null) {
        return !(
          _.filter(that.selectedSpecification.inputs, (speInput) => {
            return (
              speInput.defaultValue === null ||
              speInput.defaultValue.trim() === ""
            );
          }).length !== 0
        );
      } else {
        return true;
      }
    },
  },
  computed: {
    getServiceConfig: function (servicecode) {
      var services = _.filter(this.servicesConfig, (serviceConfig) => {
        return serviceConfig.servicecode === servicecode;
      });
      return services;
    },
    nextable() {
      console.log(this.isServiceconfig);
      if (this.isServiceconfig) {
        if(this.$store.getters.selectedIncidentType == "it-mdr"){
          return false;
        }
        let that = this;
        let selectedspcint = _.clone(this.olddataminingServices);
        var selectedServices = _.filter(this.services, (ser) => ser.isSelected);
        this.dataminingServices = _.filter(
          selectedServices,
          (ser) =>
            ser.slug === "svc-dat-bre-ana-pha-1" ||
            ser.slug === "svc-dat-bre-ana-pha-2"
        );
        this.datamining = this.dataminingServices.length >= 1 ? true : false;
        if (this.dataminingServices.length > 1) {
          _.each(this.services, function (service, index) {
            if (service.slug == that.olddataminingServices[0].slug) {
              that.services[index].isSelected = false;
            }
          });
          //For Second Time
          let selectedServices = _.filter(
            this.services,
            (ser) => ser.isSelected
          );
          this.dataminingServices = _.filter(
            selectedServices,
            (ser) =>
              ser.slug === "svc-dat-bre-ana-pha-1" ||
              ser.slug === "svc-dat-bre-ana-pha-2"
          );
          this.olddataminingServices = _.clone(this.dataminingServices);
          let selecteddmspcint = _.clone(this.dataminingServices);
          let selectedValue =
            selectedspcint[0].serviceConfig.scopes[0].inputs[0].defaultValue;
          let selecteddmValue =
            selecteddmspcint[0].serviceConfig.scopes[0].inputs[0].defaultValue;
          let selectedval = selectedValue ? selectedValue : selecteddmValue;
          this.olddataminingServices[0].serviceConfig.scopes[0].inputs[0].defaultValue =
            selectedval;
          this.selectedScopeInput(selectedval);
        } else {
          this.olddataminingServices = _.clone(this.dataminingServices);
          if (this.olddataminingServices.length >= 1) {
            let selectedval =
              this.olddataminingServices[0].serviceConfig.scopes[0].inputs[0]
                .defaultValue;
            this.selectedScopeInput(selectedval);
          }
        }
        this.$v.services.$touch();
        for (var ser in this.$v.services.$each.$iter) {
          var curService = this.$v.services.$each.$iter[ser].$model;
          if (
            _.find(
              selectedServices,
              (selService) => selService.slug === curService.slug
            )
          ) {
            if (this.$v.services.$each.$iter[ser].$invalid) {
              return true;
            }
          }
        }
        if (this.$store.getters.selectedIncidentType != "it-post-ir") {
          return !(
            !(selectedServices.length === 0) &&
            that.ValidateSpecification() &&
            _.filter(selectedServices, (service) => {
              if (service.serviceConfig) {
                let activeScopes = _.filter(
                  service.serviceConfig.scopes,
                  (scope) => {
                    return scope.isActive && scope.isSubTaskScope;
                  }
                );
                if (!service.serviceConfig.hasSubTasks) {
                  return (
                    _.filter(service.serviceConfig.scopes, (scope) => {
                      return (
                        _.filter(scope.inputs, (scopeInput) => {
                          return (
                            scopeInput.defaultValue === null ||
                            scopeInput.defaultValue.trim() === ""
                          );
                        }).length !== 0
                      );
                    }).length !== 0
                  );
                } else {
                  if (activeScopes.length !== 0) {
                    return (
                      _.filter(activeScopes, (scope) => {
                        return (
                          _.filter(scope.inputs, (scopeInput) => {
                            return (
                              scopeInput.defaultValue === null ||
                              scopeInput.defaultValue.trim() === ""
                            );
                          }).length !== 0
                        );
                      }).length !== 0
                    );
                  } else {
                    return true;
                  }
                }
              } else {
                return false;
              }
            }).length === 0
          );
        } else {
          return !(selectedServices.length === 0) ? false : true;
        }
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      selectedSubType: this.$store.getters.selectedSubofferingType,
      selectedIncidentType: this.$store.getters.selectedIncidentType,
      inputoptions: [
        { value: 0, text: "Dollar" },
        { value: 1, text: "Hour" },
        { value: 2, text: "Number" },
        { value: 3, text: "Text" },
        { value: 4, text: "Select" },
      ],
      isServiceconfig: false,
      dmservice: [],
      services: [],
      servicesConfig: [],
      editMode: false,
      addMode: false,
      editingService: {},
      editingTask: {},
      dataminingscope: [],
      dataminingscope2: [],
      datamining: false,
      editItem: {
        title: "",
        description: "",
      },
      dataminingServices: {},
      IsamendmentMode: this.$store.getters.amendmentMode,
      selectedSpecification: null,
      selectedSpecificationTwo: null,
      selectedvalue: null,
    };
  },
  validations: {
    services: {
      $each: {
        serviceConfig: {
          scopes: {
            $each: {
              inputs: {
                $each: {
                  defaultValue: {
                    // isRequired(defaultValue, scopeInput) {
                    //   if (
                    //     this.$store.getters.selectedIncidentType != "it-ran-eve"
                    //   ) {
                    //     if (
                    //       defaultValue === null ||
                    //       defaultValue.trim() === ""
                    //     ) {
                    //       return false;
                    //     } else {
                    //       return true;
                    //     }
                    //   } else {
                    //     return true;
                    //   }
                    // },
                    isValid(defaultValue, scopeInput) {
                      if (defaultValue === null || defaultValue.trim() === "") {
                        return true;
                      }
                      if (this.formatType(scopeInput.type) === "Hour") {
                        return numeric(defaultValue);
                      } else if (this.formatType(scopeInput.type) === "Text") {
                        return true;
                      } else if (
                        this.formatType(scopeInput.type) === "Select"
                      ) {
                        return true;
                      } else {
                        return decimal(defaultValue);
                      }
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.sidepanel {
  height: 100%;
  position: fixed;
  z-index: 101;
  top: 50px;
  right: 0;
  border-left: 1px solid #17a2b8;
  border-top: 1px solid #17a2b8;
  background-color: #686464;
  overflow-x: hidden;
  padding-top: 5px;
  padding-left: 5px;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  width: 500px;
  margin-top: 10px;
}
.error {
  color: red;
  border-color: #fdd;
}
</style>


